import * as i0 from '@angular/core';
import * as i1 from './pagination.module';
import * as i2 from '@angular/common';
import * as i3 from './pagination.component';
export const PaginationModuleNgFactory:i0.NgModuleFactory<i1.PaginationModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.PaginationComponent = (<any>(null as any));
var _decl0_12:i2.AsyncPipe = (<any>(null as any));
var _decl0_13:i2.UpperCasePipe = (<any>(null as any));
var _decl0_14:i2.LowerCasePipe = (<any>(null as any));
var _decl0_15:i2.JsonPipe = (<any>(null as any));
var _decl0_16:i2.SlicePipe = (<any>(null as any));
var _decl0_17:i2.DecimalPipe = (<any>(null as any));
var _decl0_18:i2.PercentPipe = (<any>(null as any));
var _decl0_19:i2.TitleCasePipe = (<any>(null as any));
var _decl0_20:i2.CurrencyPipe = (<any>(null as any));
var _decl0_21:i2.DatePipe = (<any>(null as any));
var _decl0_22:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_23:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_24:i2.KeyValuePipe = (<any>(null as any));
var _decl0_25:i2.CommonModule = (<any>(null as any));
var _decl0_26:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_27:i0.ElementRef<any> = (<any>(null as any));
function _View_PaginationComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_PaginationComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'',_decl0_11.cssClass,'');
  currVal_0;
  const currVal_1:any = _decl0_11.headTemplate;
  currVal_1;
  const currVal_2:any = i0.ɵinlineInterpolate(1,'pagination ',(_decl0_11.size? ('pagination-' + _decl0_11.size): ''),
      '');
  currVal_2;
  const currVal_3:any = _decl0_11.boundary;
  currVal_3;
  const currVal_4:any = (<any>{disabled:(_decl0_11.pageIndex == 1)});
  currVal_4;
  const currVal_5:any = _decl0_11.preLink;
  currVal_5;
  const currVal_6:any = i0.ɵinlineInterpolate(1,'',_decl0_11.preLinkCssClass,'');
  currVal_6;
  const currVal_7:any = _decl0_11.preLink;
  currVal_7;
  const currVal_8:any = (_decl0_11.showPages[0] > 1);
  currVal_8;
  const currVal_9:any = _decl0_11.showPages;
  currVal_9;
  const currVal_10:any = (_decl0_11.showPages[(_decl0_11.showPages.length - 1)] < _decl0_11.totalPage);
  currVal_10;
  const currVal_11:any = (<any>{disabled:(_decl0_11.pageIndex == _decl0_11.totalPage)});
  currVal_11;
  const currVal_12:any = _decl0_11.nextLink;
  currVal_12;
  const currVal_13:any = i0.ɵinlineInterpolate(1,'',_decl0_11.nextLinkCssClass,'');
  currVal_13;
  const currVal_14:any = _decl0_11.nextLink;
  currVal_14;
  const currVal_15:any = _decl0_11.boundary;
  currVal_15;
  const currVal_16:any = _decl0_11.tailTemplate;
  currVal_16;
  const pd_17:any = ((<any>_decl0_11.prev()) !== false);
  const pd_18:any = ((<any>_decl0_11.next()) !== false);
}
